import {
  mdiCheckboxMarked,
  mdiCheckboxBlankOutline,
  mdiMinusBox,
} from "@mdi/js";
import minifyTheme from "minify-css-string";

export default {
  breakpoint: {
    thresholds: {
      xs: 340,
      sm: 540,
      md: 800,
      lg: 1280,
    },
    scrollBarWidth: 24,
  },

  icons: {
    iconFont: "mdiSvg",
    values: {
      checkboxOn: mdiCheckboxMarked,
      checkboxOff: mdiCheckboxBlankOutline,
      checkboxIndeterminate: mdiMinusBox,
    },
  },

  theme: {
    themes: {
      light: {
        primary: "#0c3c7c",
      },
    },
    options: {
      minifyTheme,
    },
  },
};
